// ErrorFallback.js
import React from "react";
import { saveSettings } from "../../http";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  React.useEffect(() => {
    const sendErrorDetails = async () => {
      try {
        await saveSettings({
          message: error.message,
          stack: error.stack,
        });
      } catch (sendError) {
        console.error("Error reporting failed:", sendError);
      }
    };

    sendErrorDetails();
  }, [error]);

  return (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center bg-gray-100 p-4"
    >
      <div className="max-w-md rounded-lg bg-white p-8 text-center shadow-lg">
        <h2 className="mb-4 text-2xl font-bold text-red-600">
          Oops! Something went wrong
        </h2>
        <p className="mb-6 text-gray-600">
          We're sorry, but it looks like we hit a snag. Our team is already on
          it!
        </p>
        <button
          onClick={resetErrorBoundary}
          className="rounded bg-red-600 px-4 py-2 text-white transition duration-300 hover:bg-red-700"
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export default ErrorFallback;
